<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Edição de Dados</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  <div
                    v-for="(input, index) in inputsList"
                    :key="index"
                    class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2"
                  >
                    <label
                      :for="input.name"
                      class="block text-sm font-medium leading-6 text-gray-900"
                    >
                      {{ input.label }}
                    </label>

                    <!-- Select -->
                    <select
                      v-if="input.type === 'select'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :required="false"
                      :disabled="input.readonly === true"
                      :class="[
                        'mt-2 block w-full rounded-md border-0 py-1.5 px-2 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6',
                        input.readonly ? 'bg-gray-100 text-gray-500 cursor-not-allowed ring-gray-300' : 'text-gray-900 focus:ring-indigo-600 ring-gray-300'
                      ]"
                    >
                      <option value="">Selecione</option>
                      <option
                        v-for="(opt, i) in input.options || []"
                        :key="i"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>

                    <!-- Textarea -->
                    <textarea
                      v-else-if="input.type === 'textarea'"
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :readonly="input.readonly === true"
                      :placeholder="placeHolderValues[input.name]"
                      rows="3"
                      :required="false"
                      :class="[
                        'mt-2 block w-full rounded-md border-0 py-1.5 px-2 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6',
                        input.readonly ? 'bg-gray-100 text-gray-500 cursor-not-allowed ring-gray-300' : 'text-gray-900 focus:ring-indigo-600 ring-gray-300'
                      ]"
                    ></textarea>

                    <!-- Input padrão -->
                    <input
                      v-else
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :type="input.type"
                      :step="input.step || null"
                      :required="false"
                      :readonly="input.readonly === true"
                      :placeholder="placeHolderValues[input.name]"
                      :value="input.type === 'date' ? formatDate(placeHolderValues[input.name]) : data[input.name]"
                      :class="[
                        'mt-2 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6',
                        input.readonly ? 'bg-gray-100 text-gray-500 cursor-not-allowed ring-gray-300' : 'text-gray-900 focus:ring-indigo-600 ring-gray-300'
                      ]"
                    />
                  </div>
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-customPurple px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-sienaBlue">Confirmar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

  export default {
    name: 'CommonForm',
    async created(){
        
    },
    props: {
      inputsList: {
        type: Array,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      placeHolderValues: {
        type: Object,
        required: true
      }
    },  
    data() {
      return {
        data:
        {  
        },
      };
    },
    methods: {
      sendData(e) {
        e.preventDefault();
        this.$emit('editing-data', this.data,this.placeHolderValues.id);
      },
      closeDialog() {
        this.$emit('update-open', false);
      },
      formatDate(dateString) {
        if (!dateString) return '';
        
        // Verifica se o valor contém data e hora, separa apenas a data (YYYY-MM-DD)
        if (typeof dateString === 'string' && dateString.includes(' ')) {
          return dateString.split(' ')[0]; // Retorna apenas a parte da data
        }
        
        return dateString; // Retorna o valor original se já estiver no formato correto
      }
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot
    },
  }
</script>